import { useNavigate } from "react-router-dom";
import useLabels from "../hooks/useLabels";

const Unauthorized = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [getLabel] = useLabels();

  return (
    <section className="unauthorized_wrapper">
      <h1>{getLabel("unauthorized")}</h1>
      <br />
      <p>{getLabel("notEnoughPrivileges")}</p>
      <div>
        <button onClick={goBack}>{getLabel("unauthorizedGoBack")}</button>
      </div>
    </section>
  );
};

export default Unauthorized;
